import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';

document.querySelectorAll( '.logo-carousel .swiper' ).forEach( ( swiperEl ) => {
	const isAutoplay = swiperEl.dataset.autoplay === 'true';
	const perSlides = parseInt( swiperEl.dataset.slides, 10 ) || 2;
	const showButtons = swiperEl.dataset.showButtons === 'true';

	new Swiper( swiperEl, {
		modules: [ Autoplay, Navigation ],
		autoplay: isAutoplay ? { delay: 0, disableOnInteraction: false } : false,
		slidesPerView: perSlides,
		speed: 5000,
		loop: true,
		allowTouchMove: true,
		spaceBetween: 24,
		navigation: showButtons
			? {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
			  }
			: false,
		breakpoints: {
			0: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: perSlides,
			},
		},
	} );
} );
